import React from 'react';
import RemoveCircleOutline from '@mui/icons-material/RemoveCircleOutline';
import Button from '@mui/material/Button';
import IconButton from '@mui/material/IconButton';
import Loader from '@/components/common/Loader';
import LoaderSizes from '@/constants/ui/LoaderSizes';
import useContribution from '@/lib/hooks/swr/useContribution';
import translate from '@/lib/intl/translate';
import type Contribution from '@/types/api/Contribution';
import { formatCurrency } from '@/utils/currency';
import { formatDate } from '@/utils/dates';

function OpportunityContributionItem({
  contributionId,
  onView,
  onUnlink,
}: {
  contributionId: string;
  onView: (id: string) => void;
  onUnlink: (id: string) => void;
}) {
  const { data: contribution } = useContribution(contributionId);

  return (
    <tr className="grid grid-cols-[1fr_1fr_100px] items-center">
      {contribution ? (
        <>
          <td>{formatCurrency((contribution as Contribution).amount, true)}</td>
          <td>
            {formatDate((contribution as Contribution).donationDateString)}
          </td>
        </>
      ) : (
        <td colSpan={2} className="col-span-2 text-center">
          <Loader size={LoaderSizes.XS} />
        </td>
      )}
      <td className="text-right">
        <Button onClick={() => onView(contributionId)} className="p-0">
          {translate('VIEW')}
        </Button>
        <IconButton
          aria-label={translate('CONTRIBUTION_UNLINK_DONATION')}
          onClick={() => onUnlink(contributionId)}
          size="small"
          color="primary"
          title={translate('CONTRIBUTION_UNLINK_DONATION')}
        >
          <RemoveCircleOutline />
        </IconButton>
      </td>
    </tr>
  );
}

export default OpportunityContributionItem;
